import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { environment } from 'src/environments/environment';
import { CreatePoi, PoiDto, UpdatePoi } from './poi-dto';

@Injectable({
  providedIn: 'root'
})
export class PoiService {

  private url = `${environment.apiUrl}/pois`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<PoiDto[]> {
    return this.http.get<PoiDto[]>(this.url);
  }

  getTypes(): Observable<GenericDD[]> {
    return this.http
      .get<Array<{ id: string; name: string; description?: string }>>(`${this.url}/types`)
      .pipe(
        map((items) => {
          console.log('[POI][getTypes] raw response:', items);
          return items;
        }),
        map((items) =>
          items.map((item) => ({
            id: item.id,
            codice: item.name,
          }))
        ),
        map((items) => {
          console.log('[POI][getTypes] mapped response:', items);
          return items;
        })
      );
  }

  getLocations(): Observable<GenericDD[]> {
    return this.http
      .get<Array<{ id: string; name?: string }>>(`${environment.apiUrl}/missions/locations`)
      .pipe(
        map((items) => {
          console.log('[POI][getLocations] raw response:', items);
          return items;
        }),
        map((items) =>
          items.map((item) => ({
            id: item.id,
            codice: item.name ?? '',
          }))
        ),
        map((items) => {
          console.log('[POI][getLocations] mapped response:', items);
          return items;
        })
      );
  }

  create(data: CreatePoi): Observable<PoiDto> {
    return this.http.post<PoiDto>(this.url, data);
  }

  read(id: string): Observable<PoiDto> {
    return this.http.get<PoiDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdatePoi): Observable<PoiDto> {
    return this.http.put<PoiDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
